import { Outlet } from 'react-router-dom';
import { Layout, Typography } from 'antd';

/**
 * Guardian surface shell — mobile-first, no bottom tabs (the ward picker + tabs
 * live inside GuardianHomePage). Nests inside ProductShell.
 */
export function GuardianShell() {
  return (
    <Layout style={{ minHeight: 'calc(100vh - 50px)', background: '#f7f7f5' }}>
      <Layout.Content style={{ padding: '18px 18px 40px', maxWidth: 720, margin: '0 auto', width: '100%' }}>
        <div style={{ marginBottom: 12 }}>
          <Typography.Text type="secondary" style={{ fontSize: 11, letterSpacing: 0.4, textTransform: 'uppercase', fontWeight: 600 }}>
            Guardian
          </Typography.Text>
        </div>
        <Outlet />
      </Layout.Content>
    </Layout>
  );
}
